/*!
* Copyright (c) 2018-present Cyclope.ai
* LICENSE file is in the root directory of this source tree.
* */

import { Reducer } from "redux";
import *as actionsTypesFromStore from '@apps-store/@types';
import { ReducersInterface } from '@apps-store/models';
import * as actions from '@apps-store/enums';

/**
 * @function DelayedReducer
 * @param { any } sate: L'etat de l'application
 * @param {  actionsTypesFromStore.TypeDelayedAction } action: action de l'application
 * @return { Reducer }
 */
export const DelayedReducer: Reducer< ReducersInterface<any>> = ( state: any = {
   
} , action: actionsTypesFromStore.TypeDelayedAction) => {
    
    switch (action.type) {

        case actions.DelayedTypes.DELAYED_INPROGRESS:

            return {

                loading: true,
                ...state

            }
            
            break;
        case actions.DelayedTypes.DELAYED_FAIL:

            return {

                error: action.payload.error ,
                loading: false,
                
            }
            
            break;
        
        case actions.DelayedTypes.DELAYED_SUCCESS:

            return {

                data: action.payload.data ,
                loading: false,
                
            }
            
            break;
    
        default:
            return state
            break;
    }
    
}


// WEBPACK FOOTER //
// ./src/apps/store/reducers/delayed/index.ts